import { ReactNode } from 'react'

const CourseCardSkeleton = ({ className }: { className?: string }): ReactNode => (
  <div className={`h-[200px] animate-pulse rounded-2xl bg-skeleton-primary ${className}`} />
)

export const CourseCardsSkeleton = (): ReactNode => {
  return (
    <>
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
    </>
  )
}
